module.exports = __webpack_public_path__ + "static/img/lunbo6.204f74a3.webp";